import PermissionConstraint from "./PermissionConstraint"

export default new PermissionConstraint({ accounting: true })
